import Vue from "vue";
import { mapState } from "vuex";
import axios from "axios";

// Mixins
import { RestComponent } from "../../../mixins/rest-component";

// Template and media files
import "./page-homepage.scss";
import template from "./page-homepage.vhtml";
import logoAscanius from "../../../../_img/logo.svg";
import logo from "../../../../_img/logo-esbjerghavn.svg";

export const PageHomepage = Vue.component("page-homepage", {
    components: {
        logo,
        logoAscanius,
    },
    mixins: [RestComponent],
    template: template,
    props: {
        appLoaded: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        lAppInner: null,
        isLoggedIn: appData.user.isLoggedIn,
        showConfirmationBox: appData.showDeleteConfirm,
        modalText: appData.deleteMessage,
        workflows: [],
    }),
    computed: {
        website: (vm) => vm.$store.state.appsData.data.website,
        ...mapState({
            showSidebar: (state) => state.sidebar.showSidebar,
            isNavigating: (state) => state.pages.isNavigating,
        }),
    },
    watch: {
        content() {
            this.$store.commit("sidebar/updateData", {
                name: "parent",
                value: "/",
            });
        },
    },
    methods: {
        filterContent: function (content) {
            return content.map((item) =>
                Object.assign({}, item, { link: fixLink(item.link) })
            );
        },
        navigateToIndex(link, privacy) {
            if (!this.isLoggedIn && privacy === "private") {
                link = "/log-in?redirect=" + encodeURIComponent(link);
            }
            window.removeEventListener(
                "scroll",
                this.$options.throttleFunction
            );

            this.$store.commit("sidebar/updateData", {
                name: "transparentUntilLg",
                value: false,
            });
            this.$store.commit("sidebar/updateData", {
                name: "stuckToTopMobile",
                value: false,
            });
            this.navigateLeft(link);
            setTimeout(() => {
                $("html").addClass("no-scroll");
                this.$store.commit("sidebar/updateData", {
                    name: "sidebarPos",
                    value: "left",
                });
            }, 100);
        },
        toogleSidebarTransparency() {
            if (this.$el.clientWidth < 754) {
                window.pageYOffset > 50
                    ? this.$store.commit("sidebar/updateData", {
                          name: "transparentUntilLg",
                          value: false,
                      })
                    : this.$store.commit("sidebar/updateData", {
                          name: "transparentUntilLg",
                          value: true,
                      });
            }
        },
        getWorkflows() {
            axios
                .get("https://businessareas.portesbjerg.dk/api/qd/workflows")
                .then((res) => {
                    if (res.data.success) {
                        console.log(res);
                        this.workflows = res.data.workflows;
                    } else {
                        console.log("Error");
                    }
                });
        },
    },
    created() {
        this.getWorkflows();
        this.$store.dispatch("pagination/hideRightAndThenMakeFullScreen");

        this.$store.commit("pagination/updateData", {
            name: "fullWidthUntilLg",
            value: true,
        });

        this.$store.commit("sidebar/updateData", {
            name: "transparentUntilLg",
            value: true,
        });

        this.$store.commit("sidebar/updateData", {
            name: "stuckToTopMobile",
            value: true,
        });

        this.$store.commit("sidebar/updateData", {
            name: "sidebarPos",
            value: "right",
        });

        this.$nextTick(function () {
            this.$options.throttleFunction = _.throttle(
                this.toogleSidebarTransparency,
                25
            );
            window.addEventListener("scroll", this.$options.throttleFunction);
        });
    },
    mounted() {
        setTimeout(() => {
            $("html").removeClass("no-scroll");
        }, 600);
        this.$store.commit("pages/updateData", {
            name: "isNavigating",
            value: true,
        });
        setTimeout(() => {
            this.$store.commit("pages/updateData", {
                name: "isNavigating",
                value: false,
            });
        }, 600);

        setTimeout(() => {
            this.showConfirmationBox = false;
        }, 4500);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.$options.throttleFunction);
    },
});

function fixLink(link) {
    return link.replace(/https?:\/\/[^\.]+\.[^\/]+\//, "");
}



// WEBPACK FOOTER //
// ./assets/_js/components/post-types/page-homepage/page-homepage.js